import { LocationStrategy } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes';
import { MainService, HttpService } from 'app/resources/services';
import { RequestRecuperarChaveAcesso } from '../../resources/classes/request-recuperar-chave-acesso';
import { ResponseRecuperarChaveAcesso } from '../../resources/classes/response-recuperar-chave-acesso';
import { LoginBi } from '../../resources/bi/login.bi';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-chave-de-acesso',
  templateUrl: './chave-de-acesso.component.html',
  styleUrls: ['./chave-de-acesso.component.css']
})
export class ChaveDeAcessoComponent implements OnInit {

  @Input() logotipo: string;
  private bootboxAlertComId: DefineBootboxId;
  public requestRecuperarChaveAcesso: RequestRecuperarChaveAcesso;
  public siteKey: string;
  @Output() isTelaDeLogin = new EventEmitter<boolean>();

  constructor(private httpService: HttpService, private mainService: MainService, private location: LocationStrategy, public router: Router) { }

  ngOnInit() {
    this.siteKey = environment.siteKey;
    this.requestRecuperarChaveAcesso = new RequestRecuperarChaveAcesso();
    window.scrollTo(0, 0);
    this.bootboxAlertComId = new DefineBootboxId();
  }

  public irParaLogin() {
    this.isTelaDeLogin.emit(true);
  }

  public enviarEmailRecuperarChaveDeAcesso(): void {
    const requestRecuperarChaveAcessoFinal: RequestRecuperarChaveAcesso = Object.assign(new RequestRecuperarChaveAcesso(), this.requestRecuperarChaveAcesso);
    this.requestRecuperarChaveAcesso = undefined;
    new LoginBi.Rest(this.httpService).recuperarChaveAcesso(requestRecuperarChaveAcessoFinal)
      .subscribe(
        success => {
          this.irParaLogin();
          this.requestRecuperarChaveAcesso = new RequestRecuperarChaveAcesso();
          this.bootboxAlertComId.alerta(this.getMensagemRecuperacaoChaveAcesso(LoginBi.Parser.fillList(success.json())));
        },
        error => {
          this.requestRecuperarChaveAcesso = new RequestRecuperarChaveAcesso();
          this.bootboxAlertComId.alerta(error._body);
        }
      );
  }

  private getMensagemRecuperacaoChaveAcesso(items: Array<ResponseRecuperarChaveAcesso>): string {
    let msg: string;
    if (items != undefined && items.length > 0) {
      msg = '<div class="text-center";><div><i class="fa fa-envelope-o fa-5x text-success" aria-hidden="true"></i></div><br>';
      for (const item of items) {
        msg += 'Chave de acesso <strong>' + item.getChaveAcessoOfuscado() + '</strong>';
        msg += ' enviada para o email <strong>' + item.getEmailOfuscado() + '</strong><br><br>';
      }
      msg += '<div style="font-size: 0.8em">Caso não encontre, por favor verifique sua caixa de spam.<br>';
      msg += 'Endereço IP da solicitação: <strong>' + items[0].getIp() + '</strong></div></div>';
    }
    return msg;
  }

}



// WEBPACK FOOTER //
// ./src/app/public/chave-de-acesso/chave-de-acesso.component.ts